// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "", "",{"version":3,"sources":[],"names":[],"mappings":"","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"chartMarginVertical": "40px",
	"chartMarginHorizontal": "20px",
	"mainFontFamily": "\"Source Sans Pro\",\"system-ui\",\"BlinkMacSystemFont\",\"-apple-system\",\"Roboto\",\"Oxygen\",\"Ubuntu\",\"Cantarell\",\"Fira Sans\",\"Droid Sans\",\"Helvetica Neue\",\"sans-serif\"",
	"chartTitleFontSize": "20px",
	"chartTitleLineHeight": "1.25em",
	"chartTitleColor": "#212121",
	"chartTitleSecondaryColor": "#4d4d4d",
	"chartSubitleFontFamily": "\"Noto Sans\",sans-serif",
	"chartSubitleFontSize": "14px",
	"chartSubtitleLineHeight": "1.25em",
	"chartSubitleColor": "#4d4d4d",
	"chartAxisFontSize": "16px",
	"chartAxisFontColor": "#4d4d4d",
	"chartAxisTickColor": "#e6e6e6",
	"chartAxisTickColorDark": "#999"
};
export default ___CSS_LOADER_EXPORT___;
